import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from "../../../mixin/mixin.js";
import Vue from "vue";
import VueExcelEditor from "vue-excel-editor";
Vue.use(VueExcelEditor);

export default {
  mixins: [mixx],
  name: 'cuponesLiquidados',
  data() {
    return {
      msg: '-',
      data: [],
      loading: false,
      loading_f: false,
      ventas: [],
      comercios_f: [],
      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
        estado: false
      }
    }
  },
  mounted: function () {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    $(".box").boxWidget();
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  component: {
    VueExcelEditor
  },
  computed: {
    reporte: function () {
      return (
        "/billeteras/PP/cupones?dsis=" + window.sssdi +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta +
        "&estado=" +
        this.f_c.estado
      );
    }
  },
  methods: {
    consultar() {
      this.loading = true;
      this.data = [];
      this.$http
        .post(
          "/billeteras/PP/cupones", this.f_c)
        .then(response => {
          this.ventast_tabla = 0;
          if (response.data.status == 1) {
            for (let i = 0; i < response.data.data.length; i++) {
              this.data.push({
                'a': response.data.data[i][0],
                'b': response.data.data[i][1],
                'c': response.data.data[i][2],
                'd': response.data.data[i][3],
                'e': response.data.data[i][4],
                'f': response.data.data[i][5],
                'g': response.data.data[i][6],
                'h': response.data.data[i][7],
                'i': response.data.data[i][8],
                'j': response.data.data[i][9],
                'k': response.data.data[i][10],
                'l': response.data.data[i][11],
                'm': response.data.data[i][12],
                'n': response.data.data[i][13],
                'o': response.data.data[i][14]
              });
            }
          }
          this.loading = false;
        });
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/ppCupones/index.js